<template>
  <div class="card col-12" v-if="penaltyPaidData.rdy">
    <div class="card-header d-flex justify-content-between">
      <h6 class="mg-b-0">Торгуулийн төлбөр төлөлт</h6>
      <nav class="nav nav-row-xs align-items-center">
        <a
          @click="
            penaltyPaidData.params.mode = 1;
            loadPenaltyPaidData();
          "
          :class="
            `nav-link ${penaltyPaidData.params.mode == 1 ? 'active' : ''}`
          "
          role="button"
          >1D</a
        >
        <a
          @click="
            penaltyPaidData.params.mode = 2;
            loadPenaltyPaidData();
          "
          :class="
            `nav-link ${penaltyPaidData.params.mode == 2 ? 'active' : ''}`
          "
          role="button"
          >1W</a
        >
        <a
          @click="
            penaltyPaidData.params.mode = 3;
            loadPenaltyPaidData();
          "
          :class="
            `nav-link ${penaltyPaidData.params.mode == 3 ? 'active' : ''}`
          "
          role="button"
          >1M</a
        >
        <a
          @click="
            penaltyPaidData.params.mode = 4;
            loadPenaltyPaidData();
          "
          :class="
            `nav-link ${penaltyPaidData.params.mode == 4 ? 'active' : ''}`
          "
          role="button"
          >1Y</a
        >
      </nav>
    </div>
    <div class="card-body row ">
      <div class="col-sm-6 col-lg-6">
        <div class="card card-body bd-0">
          <h6
            class="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-8"
          >
            Төлөгдсөн торгуулийн тоо
          </h6>
          <div class="d-flex d-lg-block d-xl-flex align-items-end">
            <h3 class="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">
              {{ penaltyPaidData.data.count | formatMoney(0, ".", ",") }}
            </h3>
          </div>
          <div class="chart-three">
            <apexchart
              type="bar"
              height="200"
              :options="chartOptionsSpark1"
              :series="seriesSpark1"
            ></apexchart>
            <div class="text-muted tx-12">Сүүлийн 10 хоног</div>
          </div>
          <!-- chart-three -->
        </div>
      </div>
      <div class="col-sm-6 col-lg-6">
        <div class="card card-body  bd-0">
          <h6
            class="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-8"
          >
            Төлөгдсөн мөнгөн дүн
          </h6>
          <div class="d-flex d-lg-block d-xl-flex align-items-end">
            <h3 class="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">
              {{ penaltyPaidData.data.budget | formatMoney(2, ".", ",") }} ₮
            </h3>
          </div>
          <div class="chart-three">
            <apexchart
              type="bar"
              height="200"
              :options="chartOptionsSpark2"
              :series="seriesSpark2"
            ></apexchart>
            <div class="text-muted tx-12">Сүүлийн 10 хоног</div>
          </div>
          <!-- chart-three -->
        </div>
      </div>
      <!-- <div class="col-sm-6 col-lg-4">
        <div class="card card-body  bd-0">
          <h6
            class="tx-uppercase tx-11 tx-spacing-1 tx-color-02 tx-semibold mg-b-8"
          >
            Дансны хуулга
          </h6>
          <div class="d-flex d-lg-block d-xl-flex align-items-end">
            <h3 class="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">
              {{
                penaltyPaidData.data.accountBalance | formatMoney(2, ".", ",")
              }} ₮
            </h3>
          </div>
          <div class="chart-three">
            <apexchart
              type="area"
              height="100"
              :options="chartOptionsSpark3"
              :series="seriesSpark3"
            ></apexchart>
            <div class="text-muted tx-12">Сүүлийн 10 хоног</div>
          </div>
        </div>
      </div> -->
      <!-- <ul class="list-group list-group-flush tx-13">
        <li class="list-group-item d-flex pd-sm-0">
          <div class="avatar d-xs-block d-sm-block mg-r-5">
            <span class="avatar-initial rounded-circle bg-info op-5"
              ><i class="icon ion-md-car"></i
            ></span>
          </div>
          <div class="pd-sm-l-10">
            <p class="tx-medium mg-b-2">
              {{ penaltyPaidData.data.count | formatMoney(0, ".", ",") }}
            </p>
            <small class="tx-12 tx-color-03 mg-b-0"
              >Төлөгдсөн торгуулийн тоо</small
            >
          </div>
        </li>
        <li class="list-group-item d-flex pd-sm-0 mg-t-5">
          <div class="avatar d-xs-block d-sm-block mg-r-5">
            <span class="avatar-initial rounded-circle bg-success op-5"
              ><i class="icon ion-md-cash"></i
            ></span>
          </div>
          <div class="pd-sm-l-10">
            <p class="tx-medium mg-b-2">
              {{ penaltyPaidData.data.budget | formatMoney(2, ".", ",") }}
            </p>
            <small class="tx-12 tx-color-03 mg-b-0">Төлөгдсөн мөнгөн дүн</small>
          </div>
        </li>
        <li class="list-group-item d-flex pd-sm-0 mg-t-5">
          <div class="avatar d-xs-block d-sm-block mg-r-5">
            <span class="avatar-initial rounded-circle bg-success op-5"
              ><i class="icon ion-md-wallet"></i
            ></span>
          </div>
          <div class="pd-sm-l-10">
            <p class="tx-medium mg-b-2">
              {{
                penaltyPaidData.data.accountBalance | formatMoney(2, ".", ",")
              }}
            </p>
            <small class="tx-12 tx-color-03 mg-b-0">Дансны хуулга</small>
          </div>
        </li>
      </ul> -->
    </div>
    <div class="card-footer tx-11 tx-color-03 d-flex">
      <div>
        Хамрах хугацаа:
        {{ penaltyPaidData.data.processed.startDate | moment("YYYY.MM.DD") }}
        -
        {{ penaltyPaidData.data.processed.endDate | moment("YYYY.MM.DD")
        }}<br />
        Боловсруулсан:
        {{ penaltyPaidData.data.processed.time.toFixed(2) }}сек
      </div>
      <div class="mg-l-auto">
        <a @click="filterDateObj.mdl= true;" class="btn btn-primary">
          <feather type="filter"></feather>
          Огноо
        </a>
      </div>
    </div>

    <filter-date @do-search="doSearch" :mdl="filterDateObj.mdl" @on-hide="filterDateObj.mdl= false"></filter-date>
  </div>
</template>

<script>
// import "element-ui/lib/theme-chalk/index.css";
// import { DatePicker } from "element-ui";
import VueApexCharts from "vue-apexcharts";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

const moment = require("moment");
import { request } from "@/api/all";

export default {
  components: {
    apexchart: VueApexCharts,

    filterDate: () => ({
      component: import("@/views/apps/penalty/components/filterDate.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
  },
  data() {
    return {
      filterDateObj: {
        mdl: false,
        d1: null,
        d2: null
      },
      chartKey: 0,
      seriesSpark1: [
        {
          name: 'Төлөгдсөн торгуулийн тоо',
          data: [25, 66, 41, 89, 63, 25, 44, 12, 36, 9, 54],
        },
      ],
      chartOptionsSpark1: {
        chart: {
          type: "line",
          height: 200,
          // sparkline: {
          //   enabled: true,
          // },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        fill: {
          // opacity: 0.3,
        },
        xaxis: {
          crosshairs: {
            width: 1,
          },
          type: 'datetime',
          categories: []
        },
        // yaxis: {
        //   min: 0,
        // },
        title: {
          text: "",
          offsetX: 0,
          style: {
            fontSize: "24px",
          },
        },
        subtitle: {
          text: "",
          offsetX: 0,
          style: {
            fontSize: "14px",
          },
        },
      },
      seriesSpark2: [
        {
          name: 'Мөнгөн дүн',
          data: [25, 66, 41, 89, 63, 25, 44, 12, 36, 9, 54],
        },
      ],
      chartOptionsSpark2: {
        chart: {
          type: "line",
          height: 200,
          // sparkline: {
          //   enabled: true,
          // },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
        },
        fill: {
          // opacity: 0.3,
        },
        xaxis: {
          crosshairs: {
            width: 1,
          },
          type: 'datetime',
          categories: []
        },
        // yaxis: {
        //   min: 0,
        // },
        title: {
          text: "",
          offsetX: 0,
          style: {
            fontSize: "24px",
          },
        },
        subtitle: {
          text: "",
          offsetX: 0,
          style: {
            fontSize: "14px",
          },
        },
      },
      seriesSpark3: [
        {
          data: [0.1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, ],
          labels:["s"]
        },
      ],
      chartOptionsSpark3: {
        chart: {
          type: "area",
          height: 100,
          sparkline: {
            enabled: true,
          },
        },
        stroke: {
          curve: "straight",
        },
        fill: {
          opacity: 0.3,
        },
        xaxis: {
          crosshairs: {
            width: 1,
          },
        },
        yaxis: {
          min: 0,
        },
        colors:['#DCE6EC'],
        title: {
          text: "",
          offsetX: 0,
          style: {
            fontSize: "24px",
          },
        },
        subtitle: {
          text: "",
          offsetX: 0,
          style: {
            fontSize: "14px",
          },
        },
      },

      penaltyPaidData: {
        rdy: 0,
        params: {
          mode: 1,
          startDate: moment()
            .startOf("month")
            .format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
        },
        data: {
          count: 0,
          budget: 0,
          processed: {
            time: 0,
            startDate: "",
            endDate: "",
          },
        },
      },
    };
  },
  mounted() {
    this.loadPenaltyPaidData();
  },
  methods: {
    doSearch(e){
      this.penaltyPaidData.params.startDate= e.d1;
      this.penaltyPaidData.params.endDate= e.d2;
      this.penaltyPaidData.params.mode= 0;
      this.loadPenaltyPaidData();
      // this.toggleBodyClass("addClass", "dynamic-locker");
      // console.log('doSearch', e);
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    // reloadData() {
    //   this.series[0].data = this.penaltyDashboardData.data.list
    //     .filter((x) => x.show == true)
    //     .map((item) => {
    //       return { x: item.pnltTypeTask, y: item.count };
    //     });
    //   this.chartKey++;
    // },
    loadPenaltyPaidData() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "get", url: "TrafficData/PenaltyGetPaidData" },
        params: {
          mode: this.penaltyPaidData.params.mode,
          startDate: this.penaltyPaidData.params.startDate,
          endDate: this.penaltyPaidData.params.endDate,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.penaltyPaidData.data = res.data;
          this.seriesSpark1[0].data = res.data.pnltCounts.map(x=>x.count);
          this.chartOptionsSpark1.xaxis.categories = res.data.pnltCounts.map(x=>x.date);
          this.seriesSpark2[0].data = res.data.pnltBudgets.map(x=>x.count);
          this.chartOptionsSpark2.xaxis.categories = res.data.pnltBudgets.map(x=>x.date);
          this.penaltyPaidData.rdy = true;
          
          //this.vehicleCountData.processed = res.data.processed
        }
      });
    },
  },
};
</script>
